import { render, staticRenderFns } from "./PrimaryKeyField.vue?vue&type=template&id=a122c184"
import script from "./PrimaryKeyField.vue?vue&type=script&lang=js"
export * from "./PrimaryKeyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports